export default __webpack_public_path__ + "static/media/arrow.e45f70f4.svg";